import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AircraftMakeModelHttpClient } from 'src/app/shared/flight-log-api/aircraft-make-models/aircraft-make-models-client.service';
import { AssignmentToDutyEntity } from 'src/store/assignment-to-duty/assignment-to-duty.model';
import { AircraftMakeModelViewModel } from './aircraft-make-model-view-model';
import { PrdProcessingState } from './pilot-view-model';
import { PrdDutyPositionType } from './training-record-view-model';

export class AssignmentToDutyViewModel implements AssignmentToDutyEntity {
  public id: string;
  public employmentRecordId: string;
  public aircraftMakeModelId: string;
  public prdSourceSystemId: string;
  public startDate: Date;
  public endDate: Date;
  public suppressed: boolean;
  public dutyPositionType: PrdDutyPositionType;
  public processingState: PrdProcessingState;
  public processingError: string;
  public lastProcessedDate: Date;
  public aircraftMakeModel$: Observable<AircraftMakeModelViewModel | undefined>;

  constructor(assignmentToDuty: AssignmentToDutyEntity, _aircraft: AircraftMakeModelHttpClient) {
    Object.assign(this, assignmentToDuty);
    if (this.aircraftMakeModelId) {
      this.aircraftMakeModel$ = _aircraft
        .getAll({ id: this.aircraftMakeModelId })
        .pipe(map((r) => r.results[0]));
    } else {
      this.aircraftMakeModel$ = of(undefined);
    }
  }
}
